/**
 * labSearchUtils.ts
 *
 * Shared search/filter utilities matching legacy quest-lab-list.php
 * parseSearchQuery (lines 2218-2234), normalizeLabCompanyName (lines 2194-2207),
 * textMatchesTokens (lines 2241-2252).
 */

export interface ParsedQuery {
  includeTokens: string[];
  excludeTokens: string[];
}

export function parseSearchQuery(query: string): ParsedQuery {
  const includeTokens: string[] = [];
  const excludeTokens: string[] = [];

  const regex = /-?"[^"]*"|-?\S+/g;
  let match: RegExpExecArray | null;
  while ((match = regex.exec(query)) !== null) {
    let token = match[0];
    const isExclude = token.startsWith('-');
    if (isExclude) token = token.slice(1);
    token = token.replace(/^"|"$/g, '').toLowerCase().trim();
    if (token === '') continue;
    if (isExclude) {
      excludeTokens.push(token);
    } else {
      includeTokens.push(token);
    }
  }

  return { includeTokens, excludeTokens };
}

export function normalizeForSearch(text: string): string {
  return text.toLowerCase().replace(/[^a-z0-9\s]/g, ' ').replace(/\s+/g, ' ').trim();
}

export function textMatchesTokens(
  text: string,
  includeTokens: string[],
  excludeTokens: string[],
): boolean {
  const normalized = normalizeForSearch(text);
  for (const token of excludeTokens) {
    if (normalized.includes(token)) return false;
  }
  for (const token of includeTokens) {
    if (!normalized.includes(token)) return false;
  }
  return true;
}

const BUSINESS_SUFFIXES = [
  'inc', 'llc', 'corp', 'corporation', 'company', 'co', 'ltd', 'limited',
  'lp', 'llp', 'pllc', 'pc', 'pa', 'md', 'dds', 'dmd',
];

export function normalizeLabCompanyName(name: string): string {
  let normalized = name.toLowerCase().trim();
  normalized = normalized.replace(/[.,]/g, '');
  normalized = normalized.replace(/\s+/g, ' ');
  for (const suffix of BUSINESS_SUFFIXES) {
    const regex = new RegExp(`\\b${suffix}\\b`, 'gi');
    normalized = normalized.replace(regex, '');
  }
  return normalized.trim();
}
